// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dU3yF","imageContainer":"styles_imageContainer__29C5t","image":"styles_image__Ap8Io","handle":"styles_handle__8F8LV"};